import React from 'react';

function NavItems({ className }) {
  const liClasses = 'menu-item menu-time-type-post_type menu-item-object-page';

  return (
    <div className={className}>
      <ul className="dosislite-main-menu flex space-x-6">
        {[
          { path: "/", label: "Home" },
          { path: "/afspraken/", label: "Afspraken" },
          { path: "/praktisch/", label: "Praktisch" },
          { path: "/team/", label: "Team" },
          { path: "/visie/", label: "Visie/missie" },
          { path: "/nieuwepatienten/", label: "Nieuwe patiënten" },
          { path: "/contact/", label: "Contact" },
          { path: "/links/", label: "Nuttige links" }
        ].map(({ path, label }) => (
          <li key={path} className={liClasses}>
            <a href={path} style={{fontSize : '18px'}} className='text-xl'>{label}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default NavItems;
